import { render, staticRenderFns } from "./zhengfuyun.vue?vue&type=template&id=0561f957&scoped=true"
import script from "./zhengfuyun.vue?vue&type=script&lang=js"
export * from "./zhengfuyun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0561f957",
  null
  
)

export default component.exports